import {
    ExtendedApartmentBuilding,
    ExtendedPropertyType,
} from '../../api-utilities/api-utilities.types';
import { mergeDecimalRange } from '../../api-utilities/decimal-range/merge-decimal-range';
import { DecimalRange } from '../../generated';

const getExtendedModelPriceRange = (
    item: ExtendedApartmentBuilding | ExtendedPropertyType,
): DecimalRange | undefined => {
    const { constructionNumbers } = item;
    let range: DecimalRange;

    if (!constructionNumbers || !constructionNumbers.length) {
        if (!('propertyTypes' in item) || !item.propertyTypes || !item.propertyTypes.length) return;

        range = item.propertyTypes
            .filter(
                (propertyType) =>
                    propertyType.status !== 'Sold' && propertyType.status !== 'UnderConstruction',
            )
            .reduce<DecimalRange>((range, propertyType) => {
                const { rentalPrice, salesPrice } = propertyType;

                // Do not include PriceOnRequest price types
                if (rentalPrice?.amount && rentalPrice.priceType !== 'PriceOnRequest')
                    return mergeDecimalRange(range, rentalPrice.amount);
                if (salesPrice?.amount && salesPrice.priceType !== 'PriceOnRequest')
                    return mergeDecimalRange(range, salesPrice.amount);

                return range;
            }, {});
    } else {
        range = constructionNumbers
            .filter(
                (constructionNumber) =>
                    constructionNumber.status !== 'Sold' &&
                    constructionNumber.status !== 'UnderConstruction',
            )
            .reduce<DecimalRange>((range, constructionNumber) => {
                const { rentalPrice, salesPrice } = constructionNumber;

                // Do not include PriceOnRequest price types
                if (rentalPrice?.amount && rentalPrice.priceType !== 'PriceOnRequest')
                    return mergeDecimalRange(range, rentalPrice.amount);
                if (salesPrice?.amount && salesPrice.priceType !== 'PriceOnRequest')
                    return mergeDecimalRange(range, salesPrice.amount);

                return range;
            }, {});
    }

    return range;
};

export { getExtendedModelPriceRange };
